var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notfound"},[_vm._v("\n    COULD NOT FIND THE PAGE YOU WHERE LOOKING FOR.\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }